
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.75 23.25A5.256 5.256 0 0113.5 18v-5.25h-3V18c0 2.895-2.355 5.25-5.25 5.25S0 20.895 0 18c0-.426.057-.863.169-1.301a.762.762 0 01.018-.093L3.87 3.226A3.384 3.384 0 017.124.746a3.38 3.38 0 013.375 3.38V8.25h3V4.125a3.379 3.379 0 013.37-3.379 3.386 3.386 0 013.259 2.48l3.683 13.377c.01.034.017.07.021.107.112.434.168.868.168 1.29a5.256 5.256 0 01-5.25 5.25zm0-9C16.682 14.25 15 15.932 15 18s1.682 3.75 3.75 3.75S22.5 20.068 22.5 18s-1.682-3.75-3.75-3.75zm-13.5 0c-2.068 0-3.75 1.682-3.75 3.75s1.682 3.75 3.75 3.75S9 20.068 9 18s-1.682-3.75-3.75-3.75zM16.872 2.246c-.5.001-.97.197-1.324.552s-.549.826-.548 1.326v10.209a5.21 5.21 0 013.75-1.583c.936 0 1.846.251 2.644.721l-2.711-9.847a1.88 1.88 0 00-1.808-1.378l-.003-.375v.375zM5.25 12.75A5.21 5.21 0 019 14.333V4.125c.001-.501-.194-.972-.548-1.327s-.824-.551-1.324-.552a1.88 1.88 0 00-1.81 1.378l-2.71 9.846a5.203 5.203 0 012.642-.72zm8.25-1.5v-1.5h-3v1.5h3z"}})])
          )
        }
      }
    